module.exports = "/_next/static/images/banner-app-download-uscis-update-mobile-4566819eaf60698b0ea458e5d71a32a7.png";